import React from "react";
import { AlertTriangle } from "lucide-react";
import { colorOf, fmtTime } from "@/lib/schApi";

export const ConflictBadge = ({ testid }) => (
  <span data-testid={testid} title="Has an overridden conflict or confirmed warning"
    className="inline-flex items-center gap-0.5 px-1 rounded-sm bg-red-500/20 text-red-300 font-mono text-[9px] tracking-wider uppercase">
    <AlertTriangle className="h-2.5 w-2.5" /> Conflicts
  </span>
);

/** Compact color-coded event pill used in month cells and lists. */
export function EventPill({ ev, onOpen, showTime = true }) {
  const c = colorOf(ev);
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onOpen(ev); }} data-testid={`sch-event-${ev.id}`}
      className={`w-full text-left truncate rounded-sm px-1.5 py-0.5 text-[11px] leading-tight border-l-2 hover:brightness-125 transition ${ev.status !== "active" ? "opacity-50 line-through" : ""}`}
      style={{ borderColor: c, background: `${c}22`, color: "#e5e7eb" }}>
      {showTime && <span className="font-mono text-[10px] opacity-70 mr-1">{fmtTime(ev.start_time)}</span>}
      {ev.title}
      {ev.has_conflicts && <span className="ml-1 text-red-300">⚠</span>}
    </button>
  );
}

export function Legend({ meta }) {
  return (
    <div data-testid="sch-legend" className="flex flex-wrap gap-x-3 gap-y-1">
      {Object.entries(meta.categories).map(([k, label]) => (
        <span key={k} className="inline-flex items-center gap-1.5 text-[10px] text-nex-muted">
          <span className="h-2 w-2 rounded-full" style={{ background: colorOf({ category: k }) }} />{label}
        </span>
      ))}
    </div>
  );
}
